import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../styles/constants';

export const useAutocompleteStyles = makeStyles(theme => ({
	inputRoot: {
		borderRadius: '50px',
		border: `1px solid  ${COLORS.DIGITAL_PRIMARY_SECONDARY_2}`,
		backgroundColor: COLORS.BACKGROUND_BACKGROUND_CARD,
		height: theme.spacing(5),
		display: 'flex',
		gap: theme.spacing(1)
	},
	noOptionsHint: {
		display: 'inline-block',
		backgroundColor: COLORS.WHITE,
		border: `1px solid ${COLORS.BACKGROUND_INPUT}`,
		borderRadius: '2px',
		boxShadow: `0 1px 1px ${COLORS.BACKGROUND_INPUT}`,
		padding: '12px',
		cursor: 'pointer',
		width: '100%'
	},
	sendIcon: {
		cursor: 'pointer',
		color: COLORS.ICON_ORANGE,
		opacity: props => (props.emptyInput ? '0.5' : '1')
	},
	sendIconContainer: {
		marginRight: '10px'
	}
}));

export const useTextFieldStyles = makeStyles(theme => ({
	root: {
		'& .MuiInputBase-root': {
			fontSize: theme.typography.subtitle1.fontSize,
			'&:before': {
				borderBottom: 0
			},
			'&:hover:before': {
				borderBottom: 0
			},
			paddingTop: 0,
			paddingRight: '0px !important',
			color: 'rgba(100, 102, 105, 1)'
		},
		'& .MuiAutocomplete-input': {
			padding: `0px !important`
		},
		'& .MuiSvgIcon-root': {
			width: 20,
			height: 20
		},
		'& .MuiInputAdornment-root': {
			marginLeft: theme.spacing(0.5)
		}
	}
}));
